<template>
    <div class="container">
        <div :class="'row justify-content-'+(horizontal ? horizontal : 'start')+' align-items-'+(vertical ? vertical : 'end')">
            <slot :control="control"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'vertical',
        'horizontal',
    ],
    data() { return {
        control: {},
    }},
    mounted() {
        const vm = this;

        vm.$on('padreCambio', function(padre) {
            vm.$emit('broadcastPadreCambio', padre);
        });
    }
}
</script>